<div
  class="control-container"
  [ngClass]="[containerCss, attrDisable ? 'disabled' : '']"
  (mouseleave)="handleOpenState(false, true)"
  (mouseenter)="handleOpenState(true, true)"
  (appClickOutside)="handleOpenState(false, false, true)">
  <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
  <div
    class="control-content align-items-center"
    [class.invalid]="markAsInvalid || (errors && showValidationError)"
    [class.disabled]="attrDisable"
    [class.active]="!attrDisable"
    [class.cursor-pointer]="!isTextMode"
    [class.control-container--opened]="isOpened$ | async"
    appStopPropagation
    (click)="handleOpenState(true)">
    <div class="color-block" [style.background]="control.value">
      <ng-container *ngIf="isTextMode">{{ control.value }}</ng-container>
    </div>
    <div class="color-picker-wrapper">
      <color-chrome class="color-picker" [formControl]="control" [color]="control.value"></color-chrome>
    </div>
  </div>

  <app-input-error
    *ngIf="errorSection && errors"
    [errors]="errors"
    [visible]="markAsInvalid || (errors && showValidationError)"></app-input-error>
</div>

<ng-template #labelTemplate>
  <div #labelElement class="display-flex align-items-center grid-gap-4" *ngIf="label || icon">
    <label [ngClass]="[labelCss, attrDisable ? 'disable' : '']" *ngIf="label">{{ label }}</label>
    <app-icon [matTooltip]="iconTooltip" *ngIf="icon" [svg]="icon" [iconHeight]="24" [iconWidth]="24"></app-icon>
  </div>
</ng-template>
